export enum ADigitSize {
  ExtraLarge = 'ExtraLarge',
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
  ExtraSmall = 'ExtraSmall',
}

export interface ADigitProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * The size variant of the digit
   */
  size?: ADigitSize;
  /**
   * The text to render
   */
  text: string;
}
